import { translate } from "app/filters/i18nFilter";
import {
    COMPANY_ANALYSIS_COMPETITORS,
    COMPANY_ANALYSIS_CONTACTS,
    COMPANY_ANALYSIS_DIGITAL_ASSETS,
    COMPANY_ANALYSIS_OVERVIEW,
    COMPANY_ANALYSIS_SIGNALS,
    COMPANY_ANALYSIS_TECHNOLOGIES,
} from "app/pages/sales-intelligence/constants/routes";
import { EAvailabilityMode } from "app/common/services/pageClaims";
import type { NavigationTabConfig } from "app/pages/sales-intelligence/modules/company-analysis/types/navigation-tabs";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { COMPANY_ANALYSIS_TAB_NAMES } from "../constants";

export const COMPANY_ANALYSIS_TABS: readonly NavigationTabConfig[] = [
    {
        stateId: COMPANY_ANALYSIS_OVERVIEW,
        get title() {
            return translate("si.account-overview.tab.overview");
        },
        trackingName: COMPANY_ANALYSIS_TAB_NAMES.overview,
    },
    {
        stateId: COMPANY_ANALYSIS_SIGNALS,
        get title() {
            return translate("si.account-overview.tab.signals");
        },
        trackingName: COMPANY_ANALYSIS_TAB_NAMES.signals,
    },
    {
        stateId: COMPANY_ANALYSIS_DIGITAL_ASSETS,
        get title() {
            return translate("si.account-overview.tab.digital-assets");
        },
        trackingName: COMPANY_ANALYSIS_TAB_NAMES.digitalAssets,
    },
    {
        stateId: COMPANY_ANALYSIS_TECHNOLOGIES,
        get title() {
            return translate("si.account-overview.tab.technologies");
        },
        get isHidden() {
            return salesSettingsHelper.getCompanyTechnologiesFeature() === EAvailabilityMode.HIDDEN;
        },
        trackingName: COMPANY_ANALYSIS_TAB_NAMES.technologies,
    },
    {
        stateId: COMPANY_ANALYSIS_COMPETITORS,
        get title() {
            return translate("si.account-overview.tab.competitors");
        },
        get isHidden() {
            return salesSettingsHelper.getCompanyCompetitorsFeature() === EAvailabilityMode.HIDDEN;
        },
        trackingName: COMPANY_ANALYSIS_TAB_NAMES.competitors,
    },
    {
        stateId: COMPANY_ANALYSIS_CONTACTS,
        get title() {
            return translate("si.account-overview.contacts.title");
        },
        trackingName: COMPANY_ANALYSIS_TAB_NAMES.contacts,
    },
];
